module.exports = __webpack_public_path__ + "static/media/arrow-link.cc2bfbe4.svg";